export class OrganisationInfo {
	public constructor(public readonly id: string, public readonly slug: string, public readonly name: string) {}
}
